import React from 'react';
import PropTypes from 'prop-types';
import ScoringModule from './ScoringModule';
import { Grid } from '@material-ui/core';
import { buildFields, calculateGroupScore, calculateOverallScore } from '../../../util/scoringUtils';

/**
 * ScoringModules renders a list of ScoringModule components based on RUBRIC_GROUPS.
 *
 * Props:
 * - rubricGroups: object (RUBRIC_GROUPS)
 * - form: object (form state)
 * - setForm: function (form setter)
 * - disabled: boolean
 * - classes: object (for styling)
 */
const ScoringModules = ({ rubricGroups, form, setForm, disabled, classes }) => {
  const calcScore = (group) => calculateGroupScore(group, form);

  return (
    <>
      {Object.values(rubricGroups).map((group) => (
        <ScoringModule
          key={group.key}
          title={group.name}
          fields={buildFields(group, group.key, form, setForm, disabled)}
          scoreLabel={group.scoreLabel}
          scoreValue={calcScore(group)}
          classes={classes}
        />
      ))}
      <Grid item xs={12} sm={12} md={5} lg={5} className={classes.textRowSpacer} align="left">
        <label style={{ fontWeight: 600 }}>Overall Total Score</label>
      </Grid>
      <Grid item xs={false} sm={false} md={1} lg={1}></Grid>
      <Grid item xs={12} sm={12} md={5} lg={5} className={classes.textRowSpacer} align="left">
        {String(calculateOverallScore(rubricGroups, form))}
      </Grid>
      <Grid item xs={false} sm={false} md={1} lg={1}></Grid>
    </>
  );
};

ScoringModules.propTypes = {
  rubricGroups: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  setForm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
};

export default ScoringModules;
